import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Dashboard from '../../components/Dashboard';
import s from './Dashboard.css';

const Progressbar = ({ title }) => {
  return (
    <>
      <Dashboard />
    </>
  );
};

Progressbar.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(Progressbar);
